var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowDropDownFill0Wght400Grad0Opsz481(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: 48,
    viewBox: "0 -960 960 960",
    width: 48,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M480-360 280-559h400L480-360Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDropDownFill0Wght400Grad0Opsz481);
export default __webpack_public_path__ + "static/media/arrow_drop_down_FILL0_wght400_GRAD0_opsz48 (1).f8fae707c5e05b8ff15ff059d82d776c.svg";
export { ForwardRef as ReactComponent };